import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Import hooks
import { useAppSelector } from 'store/hooks';

// Import components
import { PacketsSlider } from 'components/views/vod/components/sliders';
import { Heading } from 'components/elements';

const Packets = ({ subtype }) => {
	const { t } = useTranslation();
	const packets = useAppSelector((state) => state.product_packets.data);

	if (packets.length === 0) return null;

	const extender = 'extender';
	const convertedPackets = packets.length === 1 ? [extender, packets[0], extender] : packets;

	return (
		<Wrapper>
			<HeadingSecondStyled>{t(`packets_slider_${subtype}_packets_available`)}</HeadingSecondStyled>
			<Box>
				<PacketsSlider packets={convertedPackets} />
			</Box>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	padding: 3rem 0;
	background: linear-gradient(to bottom, transparent 12%, rgba(0, 0, 0, 1) 97%);
`;

const HeadingSecondStyled = styled(Heading.Second)`
	text-align: center;
	font-weight: ${({ theme }) => theme.font.normal};
	margin-bottom: 0rem;
`;

const Box = styled.div`
	margin-top: 0.5rem;
	padding: 0 1rem;
`;

Packets.propTypes = {
	subtype: PropTypes.string
};

export default Packets;
